
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.503 13.759"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.497 6.268a6.482 6.482 0 00-.581-.627c-.5-.459-1.07-.787-1.552-1.269A3.892 3.892 0 016.715 0a5 5 0 00-1.873 1.009 6.106 6.106 0 00-1.789 6.8.645.645 0 01.061.252.424.424 0 01-.268.382.449.449 0 01-.489-.092.634.634 0 01-.115-.13 3.893 3.893 0 01-.405-3.914A5.456 5.456 0 00.01 8.764a4.644 4.644 0 00.206 1.147 4.662 4.662 0 00.55 1.322 5.178 5.178 0 003.7 2.461 5.6 5.6 0 004.556-1.223 4.545 4.545 0 001.152-5.041l-.1-.2a3.7 3.7 0 00-.612-.956l.038-.008m-2.37 4.816a2.51 2.51 0 01-.826.459 2.157 2.157 0 01-2.194-.627 2.088 2.088 0 001.6-1.567 4.309 4.309 0 00-.206-1.7 2.762 2.762 0 01.138-1.575 4.137 4.137 0 00.459.81c.581.764 1.491 1.1 1.682 2.14a1.177 1.177 0 01.046.329 2.329 2.329 0 01-.7 1.735z","fill":"#f06060"}})])
          )
        }
      }
    